import React from "react";

const DeveloperPageHeaderComponent = ({ Headers }) => {
  const logo = Headers.logo;
  const yearofexperience = Headers.data.experience;
  const projects = Headers.data.projects;
  const ongoingprojects = Headers.data.ongoingprojects;
  const aboutdeveloper = Headers.about;
  console.log(yearofexperience, projects, ongoingprojects);

  return (
    <div className="w-full flex justify-center bg-[#374151]">
      <div className="w-full flex gap-14 flex-col sm:w-full md:w-full lg:w-4/5 xl:w-5/6 px-2 md:px-0 md:mt-24 mt-10">
        <div className=" w-full flex md:justify-between justify-center  gap-x-10 flex-wrap">
          {/* Logo  */}
          <div className="flex items-center justify-center w-full md:w-auto">
            <div className="rounded-md flex items-center justify-center p-4 md:p-5 md:h-[100px]">
              <img
                src={logo}
                alt="developer"
                className="w-[150px] md:w-[200px]"
              />
            </div>
          </div>
          {/* Content  box */}
          <div className=" flex  items-center border-[#c2c2c2] border-2   rounded-md  py-3  2xl:mt-0">
            <div className="w-full  leading-[0px] px-10 flex flex-col justify-between items-center">
              <p className=" text-4xl uppercase font-bold text-white">
                {yearofexperience}
              </p>
              <p className="text-white">Established</p>
            </div>
          </div>
        </div>

        {/* Text */}
        <div className=" text-[#c2c2c2] text-[16px] leading-[27px] font-normal ">
          <p>{aboutdeveloper}</p>
        </div>
      </div>
    </div>
  );
};

export default DeveloperPageHeaderComponent;
